import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer>
          <div className="row">
            <div className="col span-1-of-2">
              <b>CONTACT US</b> <br />
              <br />
              <b>E-mail:</b> info@smilefish.com
              <br />
              <b>Phone:</b> Please fill out the form.
              <br />
              <b>Location:</b> 4590 MacArthur Blvd, Suite 500, <br />
              Newport Beach, CA 92660
            </div>
            <div className="col span-1-of-2">
              <b>ABOUT SMILEFISH CORPORATION</b>
              <br />
              <br />
              We can't help but smile because we love what we do and what we can
              accomplish for your business. Our close involvement ensures your
              mobile requirements are met beyond expectations and continues to
              be successful for your business long there after. End result -
              You'll SMILE too!
            </div>
          </div>
        </footer>
        <div className="copyright">
          <div>© 2019 Smilefish Corporation.</div>
        </div>
      </div>
    );
  }
}
